import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
// import GinScoreHeadImg from '../../assets/Game/GinRummy/images/ModalImg.png'
import "../cardModule.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import User from "../../assets/Game/GinRummy/images/user.png";
import "./GinGameScore.css";
import GinGameWinPage from "./GinGameWinPage";

const GinGameKnock = ({ showModal, multiplayerGame, botDeadValue, deadValue, continueButton, playerScore, botScore, totalBotScore, totalPlayerScore }) => {

  const [showdata, setShowdata] = useState("");
  console.log("scoringnngng", totalBotScore, totalPlayerScore)
  const userName = localStorage.getItem("userName");
  const userName2 = localStorage.getItem("userName2");
  useEffect(() => {
    async function anonymous() {
      if (totalPlayerScore > 100 || totalBotScore > 100) {
        if (totalPlayerScore > 100) {
          setShowdata("win")
        } else {
          setShowdata("loose")
        }
        console.log("true");
      } else {
        setShowdata("")
        console.log("false");
      }
    }
    anonymous()
  }, [totalBotScore, totalPlayerScore])

  return (
    <>
      {console.log("scoringggggggg", totalBotScore, totalPlayerScore)}
      {console.log("multiplayerGameCheckPop", multiplayerGame)}
{(multiplayerGame == "multiplayer_Game") ? 
<>
{((totalBotScore >= 100) || (totalPlayerScore >= 100)) ? <GinGameWinPage totalBotScore={totalBotScore} totalPlayerScore={totalPlayerScore} setShow={setShowdata} showdata={showdata} multiplayerGame={multiplayerGame}/> :
        <Modal
          size="lg"
          show={showModal}
          aria-labelledby="GinGameScoreCard"
          centered
        >
          <Modal.Body>
            {console.log("knckbtn")}
            <Row className="justify-content-center">
              <Col xs={6} md={5} lg={4}>
                <Card className="p-3">
                  <Card.Img variant="top" src={User} className="img-fluid m-auto userImgs" />
                  <Card.Body className="p-0">
                    <Card.Text className="text-center fw-bold my-2 text-capitalize">{userName2}</Card.Text>
                    <Card.Title className="text-center mb-2">Deadwood({botDeadValue})</Card.Title>
                    <p className="text-center mb-0 h5 fw-bold">
                      <span>Score</span> {botScore.score}
                    </p>

                    {console.log("botScoreCheck", botScore, "------", playerScore)}
                    {botScore.undercut > 0 ? (

                      <p className="text-center mb-0 h5 fw-bold">
                        <span>+</span>
                        <span>Undercut</span> {botScore.undercut}
                      </p>
                    ) :
                      botScore.gin > 0 ? (
                        <p className="text-center mb-0 h5 fw-bold">
                          <span>+</span>
                          <span>Gin</span> {botScore.gin}
                        </p>
                      ) :

                        botScore.bigGin > 0 ? (
                          <p className="text-center mb-0 h5 fw-bold">
                            <span>+</span>
                            <span>BigGin</span> {botScore.bigGin}
                          </p>
                        ) :

                          (
                            ""
                          )
                    }
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={6} md={5} lg={4}>
                <Card className="p-3">
                  <Card.Img variant="top" src={User} className="img-fluid m-auto userImgs" />
                  <Card.Body className="p-0">
                    <Card.Text className="text-center fw-bold my-2 text-capitalize">{userName}</Card.Text>
                    <Card.Title className="text-center mb-0">Deadwood({deadValue})</Card.Title>
                    {/* <Card.Title className="text-center mb-0 h2">Score</Card.Title> */}
                    <p className="text-center mb-0 h5 fw-bold">
                      <span>score </span>
                      {console.log("scorePlaeyer", playerScore.score)}
                      {playerScore.score}
                    </p>
                    {playerScore.undercut > 0 ? (
                      <p className="text-center mb-0 h5 fw-bold">
                        {" "}
                        <span>+</span>
                        <span>Undercut </span>
                        {playerScore.undercut}
                      </p>
                    ) :
                      playerScore.gin > 0 ? (
                        <p className="text-center mb-0 h5 fw-bold">
                          {" "}
                          <span>+</span>
                          <span>Gin </span>
                          {playerScore.gin}
                        </p>
                      )
                        :
                        playerScore.bigGin > 0 ? (
                          <p className="text-center mb-0 h5 fw-bold">
                            {" "}
                            <span>+</span>
                            <span>BigGin</span>
                            {playerScore.bigGin}
                          </p>
                        )
                          :
                          (
                            ""
                          )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div className="text-center">
              <button className="continueBtn mt-2" onClick={(e)=>continueButton(e)}>
                Continue
              </button>
            </div>
          </Modal.Body>
        </Modal>
      }
</>
:
<>
{((totalBotScore >= 100) || (totalPlayerScore >= 100)) ? <GinGameWinPage totalBotScore={totalBotScore} totalPlayerScore={totalPlayerScore} setShow={setShowdata} showdata={showdata} /> :
        <Modal
          size="lg"
          show={showModal}
          aria-labelledby="GinGameScoreCard"
          centered
        >
          <Modal.Body>
            {console.log("knckbtn")}
            <Row className="justify-content-center">
              <Col xs={6} md={5} lg={4}>
                <Card className="p-3">
                  <Card.Img variant="top" src={User} className="img-fluid m-auto userImgs" />
                  <Card.Body className="p-0">
                    <Card.Text className="text-center fw-bold my-2 text-capitalize">Jarvis</Card.Text>
                    <Card.Title className="text-center mb-2">Deadwood({botDeadValue})</Card.Title>
                    <p className="text-center mb-0 h5 fw-bold">
                      <span>Score</span> {botScore.score}
                    </p>

                    {console.log("botScoreCheck", botScore, "------", playerScore)}
                    {botScore.undercut > 0 ? (

                      <p className="text-center mb-0 h5 fw-bold">
                        <span>+</span>
                        <span>Undercut</span> {botScore.undercut}
                      </p>
                    ) :
                      botScore.gin > 0 ? (
                        <p className="text-center mb-0 h5 fw-bold">
                          <span>+</span>
                          <span>Gin</span> {botScore.gin}
                        </p>
                      ) :

                        botScore.bigGin > 0 ? (
                          <p className="text-center mb-0 h5 fw-bold">
                            <span>+</span>
                            <span>BigGin</span> {botScore.bigGin}
                          </p>
                        ) :

                          (
                            ""
                          )
                    }
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={6} md={5} lg={4}>
                <Card className="p-3">
                  <Card.Img variant="top" src={User} className="img-fluid m-auto userImgs" />
                  <Card.Body className="p-0">
                    <Card.Text className="text-center fw-bold my-2 text-capitalize">{userName}</Card.Text>
                    <Card.Title className="text-center mb-0">Deadwood({deadValue})</Card.Title>
                    {/* <Card.Title className="text-center mb-0 h2">Score</Card.Title> */}
                    <p className="text-center mb-0 h5 fw-bold">
                      <span>score </span>
                      {console.log("scorePlaeyer", playerScore.score)}
                      {playerScore.score}
                    </p>
                    {playerScore.undercut > 0 ? (
                      <p className="text-center mb-0 h5 fw-bold">
                        {" "}
                        <span>+</span>
                        <span>Undercut </span>
                        {playerScore.undercut}
                      </p>
                    ) :
                      playerScore.gin > 0 ? (
                        <p className="text-center mb-0 h5 fw-bold">
                          {" "}
                          <span>+</span>
                          <span>Gin </span>
                          {playerScore.gin}
                        </p>
                      )
                        :
                        playerScore.bigGin > 0 ? (
                          <p className="text-center mb-0 h5 fw-bold">
                            {" "}
                            <span>+</span>
                            <span>BigGin</span>
                            {playerScore.bigGin}
                          </p>
                        )
                          :
                          (
                            ""
                          )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div className="text-center">
              <button className="continueBtn mt-2" onClick={() => continueButton()}>
                Continue
              </button>
            </div>
          </Modal.Body>
        </Modal>
      }
</>

}
     
    </>
 
  );
};

export default GinGameKnock;
